import { fetchCapaPdf } from '../api/capaPdfAPI';
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isLoaded: false,
    loading: false,
    carteiraCapaPDF: '',
};
export const capaPdfSlice = createSlice({
    name: 'capaPDF',
    initialState,
    reducers: {
        resetCapaPDF: () => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCapaPdf.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchCapaPdf.fulfilled, (state, action) => {
            state.loading = false;
            state.isLoaded = true;
            state.carteiraCapaPDF = action.payload.CapaPDF;
        });
        builder.addCase(fetchCapaPdf.rejected, (state) => {
            state.loading = false;
        });
    },
});
export const { resetCapaPDF } = capaPdfSlice.actions;
export default capaPdfSlice.reducer;
